import React from 'react'
import { SVGIconProps } from '../types'
const SvgAmpStories = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M7 4h10v15H7zM3 6h2v11H3zm16 0h2v11h-2z" />
  </svg>
)
export default SvgAmpStories
